import type { CSSProperties } from "react";

import clickSound from "./data/click-sound.base64.json";

export function getShowHideStyle(isDisplay: boolean): CSSProperties {
	return { display: isDisplay ? "inline-block" : "none" };
}

export function getVideoStyles(isDisplay: boolean, isImageMirror: boolean): CSSProperties {
	return {
		display: isDisplay ? "inline-block" : "none",
		transform: isImageMirror ? "rotateY(180deg)" : "none",
	};
}

export function playClickAudio() {
	void new Audio(`data:audio/mp3;base64,${clickSound.base64}`).play();
}

export function printCameraInfo(info: string) {
	console.info("react-html5-camera-photo info:", info);
}
